export const toBool = (value, fallback = false) => {
  if (typeof value === 'boolean') return value;
  if (typeof value === 'number') return value !== 0;
  if (typeof value === 'string') {
    const normalized = value.trim().toLowerCase();
    if (['1', 'true', 'yes', 'on'].includes(normalized)) return true;
    if (['0', 'false', 'no', 'off'].includes(normalized)) return false;
  }
  return Boolean(fallback);
};

export const toFiniteCount = (value) => {
  if (value === null || value === undefined) return null;
  if (typeof value === 'boolean') return null;
  if (typeof value === 'string' && !value.trim()) return null;
  const parsed = Number(value);
  if (!Number.isFinite(parsed)) return null;
  return Math.max(0, Math.trunc(parsed));
};

export const toFiniteNumber = (value) => {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : null;
};

export const formatResizeDisplay = (mode) => {
  const normalized = String(mode || '').trim().toLowerCase();
  if (!normalized || normalized === 'n/a') return 'N/A';
  return normalized === 'original' ? 'none' : normalized;
};

export const formatStartedAt = (value) => {
  const parsed = new Date(value);
  return Number.isNaN(parsed.getTime()) ? 'In progress' : parsed.toLocaleString();
};

export const formatTokenCount = (value) => {
  const parsed = toFiniteCount(value);
  if (parsed === null) return 'N/A';
  return parsed.toLocaleString();
};

export const formatEta = (valueSeconds) => {
  const totalSeconds = toFiniteNumber(valueSeconds);
  if (totalSeconds === null || totalSeconds < 0) return '-';
  const seconds = Math.round(totalSeconds);
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const secs = seconds % 60;
  if (hours > 0) return `${hours}h ${minutes}m`;
  if (minutes > 0) return `${minutes}m ${secs}s`;
  return `${secs}s`;
};

export const formatExportTimestamp = (value) => {
  const parsed = new Date(value);
  return Number.isNaN(parsed.getTime()) ? '' : parsed.toISOString();
};

export const getItemExplanation = (item = {}) => {
  const candidates = [
    item?.explanation,
    item?.margin_analysis,
    item?.marginAnalysis,
    item?.price_explanation,
    item?.price_reasoning,
    item?.reasoning,
  ];
  for (const candidate of candidates) {
    if (typeof candidate === 'string' && candidate.trim()) {
      return candidate.trim();
    }
  }
  return '';
};

export const getFileExtension = (filename = '') => {
  const splitName = String(filename).split('.');
  if (splitName.length < 2) return '';
  return splitName.pop().toLowerCase();
};

export const getFileExtensionFromUrl = (url = '') => {
  const cleanUrl = String(url || '').split('?')[0].split('#')[0];
  const namePart = cleanUrl.split('/').pop() || '';
  return getFileExtension(namePart);
};

export const BOUNDING_BOX_COLORS = [
  'border-red-500 bg-red-500',
  'border-blue-500 bg-blue-500',
  'border-green-500 bg-green-500',
  'border-yellow-500 bg-yellow-500',
  'border-purple-500 bg-purple-500',
  'border-orange-500 bg-orange-500',
  'border-pink-500 bg-pink-500',
  'border-cyan-500 bg-cyan-500',
  'border-indigo-500 bg-indigo-500',
  'border-teal-500 bg-teal-500',
];
